import React, { useEffect, useState } from "react";
import { corefetch, corepost, ImageURL } from "../../../Util/axios_core_helper";
import { CommonErrorMsg, ErrorMsg, ValidateForm } from "../../../Util/common";
import { KendoDatePicker } from "../../../Kendo/kendo_datepicker";
import { useNavigate, useParams } from "react-router-dom";

export const CartList = () => {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const [isMeridianClient, setIsMeridianClient] = useState(false);
  const [isToggleOn, setIsToggleOn] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ballroomData, setBallroomData] = useState([]);
  const [showThankYouModal, setShowThankYouModal] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [items, setItems] = useState([]);
  const [BreadcrumList, setBreadcrumList] = useState([]);

  const [vendor, setVendor] = useState({
    MeridianCustomerId: 0,
    ClientName: "",
    EventDate: "",
    BallroomID: 0,
    ClientPhoneNumber: "",
    ClientEmailID: "",
    Name: "",
    Email: "",
    PhoneNumber: "",
    OutsideEventDate: "",
    VenueLocation: "",
    IsMeridianClient: 0,
  });
  const [error, setError] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await corefetch(`Rental/GetRentalItemDetails`);

        if (response && response.length > 0) {
          const mappedItems = response.map((item) => ({
            ...item,
            image:
              item.imageModels.length > 0
                ? `${ImageURL}${item.imageModels[0].imagePath}`
                : null,
          }));

          setItems(mappedItems);
          updateCartWithLatestItems(mappedItems); // Update cart with the latest details
        } else {
          setItems([]);
        }
      } catch (error) {
        setItems([]);
        console.error("Error fetching items:", error);
      }
    };

    fetchData();
  }, []);
  // Run only once on component mount

  useEffect(() => {
    // Fetch cart items from localStorage
    const storedCart = localStorage.getItem("cart_items");
    if (storedCart) {
      setCartItems(JSON.parse(storedCart));
    }

    // Update navbar styles (existing logic)
    const $ = window.jQuery;
    if (!$) return;
    const paymentIcon = $(".payment");
    const cartIcon = $(".cart");
    const navbar = $(".navbar");
    const logo = $(".navbar .logo> img");
    navbar.addClass("shared-banner-style");
    logo.attr("src", "/assets/images/corporate-img/img/logo/meridian.png");
    if (navbar.hasClass("shared-banner-style")) {
      $(".navbar .navbar-nav .nav-link").css("color", "#000");
      $(".dropdown .nav-link i").css("color", "black");
      $(".payment ,.cart")
        .css({
          color: "black",
          display: "block",
          visibility: "visible",
          opacity: 1,
          position: "relative",
          zIndex: 9999,
          top: "10px",
        })
        .addClass("force-black");
    }
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      $(".payment ,.cart")
        .css({
          color: "black",
          display: "block",
          visibility: "visible",
          opacity: 1,
          position: "relative",
          zIndex: 9999,
          top: "10px",
        })
        .addClass("force-black");
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleToggleChange = () => {
    setIsToggleOn((prev) => !prev);
  };

  const handleDateChange = (e) => {
    const selectedDate = e ? e : null;
    if (selectedDate == null || selectedDate == "") {
      setVendor((prev) => ({
        ...prev,
        EventDate: null,
      }));
      setError((prevErr) => ({
        ...prevErr,
        EventDate: true,
      }));
    } else {
      setVendor((prev) => ({
        ...prev,
        EventDate: selectedDate,
      }));
      setError((prevErr) => ({
        ...prevErr,
        EventDate: false,
      }));
    }
  };
  const handleOutsideDateChange = (e) => {
    const selectedDate = e ? e : null;
    if (selectedDate == null) {
      setVendor((prev) => ({
        ...prev,
        OutsideEventDate: null,
      }));
      setError({ ...error, OutsideEventDate: true });
    } else {
      setVendor((prev) => ({
        ...prev,
        OutsideEventDate: selectedDate,
      }));
      setError({ ...error, OutsideEventDate: false });
    }
  };
  const onValidation = (field, value) => {
    if (value === "") {
      setError((prev) => ({ ...prev, [field]: true }));
    } else {
      setError((prev) => ({ ...prev, [field]: false }));
    }
  };
  const clearForm = () => {
    setVendor({
      ClientName: "",
      EventDate: "",
      BallroomID: 0,
      ClientPhoneNumber: "",
      ClientEmailID: "",
      Name: "",
      Email: "",
      PhoneNumber: "",
      VenueLocation: "",
      OutsideEventDate: "",
    });
    setError({});
    setIsToggleOn(false);

    const form = document.getElementById("form-culture-config");
    if (form) {
      form.reset();
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let err = ValidateForm(e) || {};
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    let rawPhoneValue = vendor.ClientPhoneNumber.replace(/\D/g, "");
    let rawPhoneValues = vendor.PhoneNumber.replace(/\D/g, "");

    if (isToggleOn) {
      if (!vendor.ClientPhoneNumber) {
        err.ClientPhoneNumber = "Phone number is required";
      } else if (rawPhoneValue.length !== 10) {
        err.ClientPhoneNumber = "Phone number must be 10 digits";
      }
      if (!vendor.BallroomID || vendor.BallroomID === "0") {
        err.BallroomID = true;
      }
      if (!vendor.ClientEmailID) {
        err.ClientEmailID = "Email ID is required";
      } else if (!emailPattern.test(vendor.ClientEmailID)) {
        err.ValidEmail = "Invalid email address";
      }
    } else {
      if (!vendor.Email) {
        err.Email = "Email ID is required";
      } else if (!emailPattern.test(vendor.Email)) {
        err.ValidEmail = "Invalid email address";
      }
      if (!vendor.PhoneNumber) {
        err.PhoneNumber = "Phone number is required";
      } else if (rawPhoneValues.length !== 10) {
        err.PhoneNumber = "Phone number must be 10 digits";
      }
    }
    if (Object.keys(err).length > 0) {
      setError(err);
    } else {
      // If there are no errors, proceed to form submission
      const formData = new FormData();

      const cartItems = JSON.parse(localStorage.getItem("cart_items")) || [];

      // If there are cart items, append them to the form data
      // If there are cart items, append them to the form data
      cartItems.forEach((item, index) => {
        formData.append(`QuoteDetails[${index}].ItemID`, item.itemid); // Match "ItemID"
        formData.append(`QuoteDetails[${index}].ItemName`, item.itemName); // Match "ItemName"
        formData.append(`QuoteDetails[${index}].Category`, item.category); // Match "Category"
        formData.append(`QuoteDetails[${index}].Quantity`, item.quantity);
        formData.append(`QuoteDetails[${index}].ImagePath`, item.imagePath); // Match "Quantity"
      });

      formData.append("ClientName", vendor.ClientName);

      formData.append(
        "EventDate",
        vendor.EventDate
          ? new Date(vendor.EventDate).toLocaleString()
          : new Date().toLocaleString()
      );
      formData.append(
        "OutsideEventDate",
        vendor.OutsideEventDate
          ? new Date(vendor.OutsideEventDate).toLocaleString()
          : new Date().toLocaleString()
      );

      // formData.append("eventDate", vendor.EventDate);
      formData.append("BallroomID", vendor.BallroomID);
      formData.append("ClientPhonenumber", vendor.ClientPhoneNumber);
      formData.append("Name", vendor.Name);
      formData.append("ClientEmailID", vendor.ClientEmailID);
      formData.append("EmailId", vendor.Email);
      formData.append("PhoneNumber", vendor.PhoneNumber);
      formData.append("VenueLocation", vendor.VenueLocation);
      formData.append("IsMeridianClient", isToggleOn ? "1" : "0");
      try {
        await corepost(
          "Rental/InsertUpdateCustomerDetails",
          formData,
          false,
          false,
          false,
          false
        );
        localStorage.removeItem("cart_items");
        localStorage.removeItem("cart_count");
        setCartItems([]);
        setCartCount(0);
        window.dispatchEvent(new Event("cartUpdated"));
        clearForm();
        closeModal();
        setShowThankYouModal(true);
        setTimeout(() => {
          setShowThankYouModal(false);
        }, 2000);
      } catch (error) {
        console.error("Error saving vendor data:", error);
      }
    }

    return;
  };
  const closeModal = () => {
    setShowModal(false);
    clearForm();
  };
  const fetchBallroomData = async () => {
    try {
      const list = await corefetch("Facility/GetActiveBallroomData");
      if (list && list.length > 0) {
        setBallroomData(list);
      }
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };

  const fetchBreadcrumImageData = async () => {
        try {
          const response = await corefetch(
            "Breadcrum/GetBreadcrumDetailsByCategory?CategoryCode=RCARTLIST"
          );
          if (response && response.length > 0) {
            console.log("fxftyxfyt:", response);
            setBreadcrumList(response);
          } else {
            setBreadcrumList([]);
            console.log("No Breadcrum found");
          }
        } catch (error) {
          console.error("Error fetching Breadcrum List:", error);
          setBreadcrumList([]);
        }
      };

  useEffect(() => {
    fetchBallroomData();
    fetchBreadcrumImageData();
  }, []);
 
    const backgroundImageStyle = BreadcrumList[0]
    ? {
        backgroundImage: `url(${ImageURL}${BreadcrumList[0].imagePath})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : {};
  const openModal = () => {
    fetchBallroomData();
    setShowModal(true);
  };
  const closeThankYouModal = () => {
    setShowThankYouModal(false);
  };
  const handleBack = () => {
    navigate(-1); // Navigate to the previous page
  };
  const handlePreviousPreviousPage = () => {
    navigate(-2); // Navigate two steps back
  };
  const handlePreviousPreviousPreviousPage = () => {
    navigate(-4); // Navigate two steps back
  };
  useEffect(() => {
    if (showModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [showModal]);
  const updateCartWithLatestItems = (latestItems) => {
    let storedCart = JSON.parse(localStorage.getItem("cart_items")) || [];

    let isUpdated = false; // Track if any item is updated

    let updatedCart = storedCart.map((cartItem) => {
      let updatedItem = latestItems.find(
        (item) =>
          item.itemID === cartItem.itemID || item.itemID === cartItem.itemid // Handle case difference
      );

      if (updatedItem && updatedItem.itemName !== cartItem.itemName) {
        isUpdated = true; // Mark as updated
        return { ...cartItem, itemName: updatedItem.itemName };
      }

      return cartItem;
    });

    // Only update localStorage if at least one item has changed
    if (isUpdated) {
      localStorage.setItem("cart_items", JSON.stringify(updatedCart));
      setCartItems(updatedCart);
    }
  };
  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        // Reload the page if coming from the cache
        window.location.reload();
      } else {
        // Normal case: update cart items from localStorage
        const storedCart = JSON.parse(localStorage.getItem("cart_items")) || [];
        setCartItems(storedCart);
        setCartCount(storedCart.length);
      }
    };

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  return (
    <>
      <div className="wpo-page-title"  style={backgroundImageStyle}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <div
                className="wpo-breadcumb-wrap"
                style={{ textAlign: "center" }}
              >
                <h2 style={{ color: "white" }}>Cart List</h2>
                <ol
                  className="wpo-breadcumb-wrap"
                  style={{
                    color: "white",
                    display: "inline-block",
                    padding: 0,
                  }}
                >
                  <li>
                    <span
                      onClick={handlePreviousPreviousPage}
                      style={{ cursor: "pointer", color: "white" }}
                    >
                      Rental Items
                    </span>
                  </li>
                  <span style={{ color: "white", margin: "0 5px" }}>|</span>
                  <li>
                    <span
                      // onClick={handlePreviousPreviousPreviousPage}
                      style={{ cursor: "pointer", color: "white" }}
                    >
                      <a href="/categoriesDetails"> Rental Category</a>
                    </span>
                  </li>
                  <span style={{ color: "white", margin: "0 5px" }}>|</span>
                  <li>
                    <span
                      // onClick={handleBack}
                      style={{
                        cursor: "pointer",
                        color: "white",
                        textDecoration: "underline",
                        textUnderlineOffset: "5px",
                      }}
                    >
                      Cart List
                    </span>
                  </li>
                </ol>
              </div>
            </div>
          </div>{" "}
        </div>{" "}
      </div>
      <section>
        <div className="cart-container">
          <div className="cart-sub-container">
            <div className="cart-table-main">
              <table className="cart-table">
                <thead>
                  <tr>
                    <th className="thead-cart-item">
                      <h3>Item Name</h3>
                    </th>
                    <th className="thead-cart-item">
                      <h3>Item Image</h3>
                    </th>

                    <th className="thead-quantity">
                      <h4>Quantity</h4>
                    </th>

                    <th className="thead-actions" />
                  </tr>
                </thead>
                <tbody>
                  {cartItems.length > 0 ? (
                    cartItems.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <div className="cart-item-image itemWidth">
                            {item.itemName}
                          </div>
                        </td>
                        <td>
                          <div className="cart-item-image">
                            <img
                              src={`${ImageURL}${item.imagePath}`}
                              alt={item.itemName}
                              width="100"
                            />
                          </div>
                        </td>

                        <td>
                          <div className="_p-add-cart ">
                            <div className="_p-qty offers-header">
                              <div
                                className="value-button decrease_"
                                id
                                value="Decrease Value"
                                onClick={() => updateQuantity(index, -1)}
                              >
                                -
                              </div>
                              <input
                                name="qty"
                                id="number"
                                type="number"
                                value={item.quantity}
                                readOnly
                              />
                              <div
                                className="value-button increase_"
                                id
                                value="Increase Value"
                                onClick={() => updateQuantity(index, 1)}
                              >
                                +
                              </div>
                            </div>
                          </div>
                        </td>

                        <td>
                          <button
                            type="button"
                            className="fa fa-times"
                            onClick={() => removeItem(index)}
                            style={{ fontSize: "25px" }}
                          >
                            {/* <img
                              src="../images/rentals/Cart icon/delete icon.png"
                              alt="delete"
                            /> */}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5">
                        <h4>No items in the cart</h4>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="buttonout text-end">
                <a href="/categoriesDetails">
                  <button
                    className="CartButtonOutline"
                    style={{ marginRight: "10px" }}
                  >
                    Continue Shopping
                  </button>
                </a>

                <a
                  //   href="#"
                  onClick={openModal}
                  //   onClick={() => setShowModal(true)}
                >
                  <button
                    className="CartButtons"
                    disabled={cartItems.length === 0}
                  >
                    Get Quote
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Modal for Meridian Client Toggle */}
      {showModal && (
        <div className="popup">
          <div className="modal-content venues">
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            {/* <h3>Are you a Meridian Client?</h3> */}
            <form
              id="form-culture-config"
              className="styled-form"
              onSubmit={handleSubmit}
            >
              <div className="form-section custom row align-items-center">
                <div className="col-md-7 col-12 text-md-end text-center mb-2 mb-md-0">
                  <label className="toggle">
                    Is Your Event is at Meridian?
                  </label>
                </div>
                <div className="col-md-5 col-12 d-flex justify-content-center justify-content-md-start">
                  <div className="toggle-switch">
                    <input
                      type="checkbox"
                      id="meridian-toggle"
                      name="meridianEvent"
                      onChange={handleToggleChange}
                      checked={isToggleOn}
                    />
                    <label htmlFor="meridian-toggle" className="toggle-label" />
                  </div>
                </div>
              </div>

              {isToggleOn ? (
                // Meridian Clients Form
                <div key="meridian-form" className="form-section margin">
                  <div className="row">
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="clientName"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Client Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="control form-control"
                        placeholder="Enter Client Name"
                        name="ClientName"
                        value={vendor.ClientName}
                        data-required="true"
                        onChange={(e) => {
                          setVendor({ ...vendor, ClientName: e.target.value });
                          onValidation("ClientName", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text="Client Name is required"
                        IsError={error.ClientName}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="email"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Email ID <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="control form-control"
                        placeholder="Enter Email ID"
                        name="ClientEmailID"
                        value={vendor.ClientEmailID}
                        data-required="true"
                        onChange={(e) => {
                          setVendor((prev) => ({
                            ...prev,
                            ClientEmailID: e.target.value,
                          }));
                          onValidation("ClientEmailID", e.target.value);
                          // Email validation
                          const emailPattern =
                            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

                          // Check if the email is valid or not
                          if (
                            !emailPattern.test(e.target.value) &&
                            e.target.value !== ""
                          ) {
                            setError((prevError) => ({
                              ...prevError,
                              ValidEmail: true,
                            }));
                          } else {
                            setError((prevError) => ({
                              ...prevError,
                              ValidEmail: false,
                            }));
                          }
                        }}
                      />
                      {error.ValidEmail && (
                        <ErrorMsg text="Please provide a valid email address" />
                      )}
                      <CommonErrorMsg
                        text="Email ID is required"
                        IsError={error.ClientEmailID}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label htmlFor="eventDate">Event Date</label>
                      <KendoDatePicker
                        name="EventDate"
                        value={vendor.EventDate}
                        format="MM/dd/yyyy"
                        onChange={handleDateChange}
                        disablePast={true}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="vendorType"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Ballroom <span className="text-danger">*</span>
                      </label>
                      <select
                        id="vendorType"
                        className="control form-control"
                        name="BallroomID"
                        value={vendor.BallroomID}
                        onChange={(e) => {
                          const value = parseInt(e.target.value, 10);
                          if (vendor) {
                            setVendor((prev) => ({
                              ...prev,
                              BallroomID: value,
                            }));
                            onValidation("BallroomID", value);
                          }
                        }}
                      >
                        <option value={0} disabled>
                          Select Ballroom
                        </option>
                        {ballroomData.map((ballroom) => (
                          <option
                            key={ballroom.facilityID}
                            value={ballroom.facilityID}
                          >
                            {ballroom.facilityName}
                          </option>
                        ))}
                      </select>
                      <CommonErrorMsg
                        text="Ballroom is required"
                        IsError={error.BallroomID}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="phoneNo"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Phone No <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="control form-control"
                        placeholder="Enter PhoneNumber"
                        name="ClientPhoneNumber"
                        value={vendor.ClientPhoneNumber || ""}
                        data-required="true"
                        onChange={(e) => {
                          // Clear previous error message
                          setError((prevError) => ({
                            ...prevError,
                            ClientPhoneNumber: false, // Clear the 'PhoneNumber' required error
                            invalidNo: false, // Clear the 'invalidNo' error state
                          }));

                          let rawValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

                          // Limit the number of digits to 10
                          if (rawValue.length > 10)
                            rawValue = rawValue.substring(0, 10);

                          // Format the phone number as (XXX) XXX-XXXX
                          let formattedValue = "";
                          if (rawValue.length > 3) {
                            formattedValue = `(${rawValue.substring(
                              0,
                              3
                            )}) ${rawValue.substring(3, 6)}${
                              rawValue.length > 6
                                ? "-" + rawValue.substring(6)
                                : ""
                            }`;
                          } else if (rawValue.length > 0) {
                            formattedValue = `(${rawValue}`;
                          }

                          // Update the phone number in the vendor state
                          setVendor((prev) => ({
                            ...prev,
                            ClientPhoneNumber: formattedValue,
                          }));

                          if (rawValue.length === 0) {
                            setError((prevError) => ({
                              ...prevError,
                              ClientPhoneNumber: true, // Set error for empty phone number
                              invalidNo: false, // Clear the invalid number error
                            }));
                          } else if (rawValue.length < 10) {
                            setError((prevError) => ({
                              ...prevError,
                              invalidNo: true, // Set error for invalid number
                              ClientPhoneNumber: false, // Clear the required error
                            }));
                          } else {
                            // Clear all errors if the phone number is valid
                            setError((prevError) => ({
                              ...prevError,
                              ClientPhoneNumber: false,
                              invalidNo: false,
                            }));
                          }

                          onValidation("ClientPhoneNumber", formattedValue);
                        }}
                      />
                      {error.invalidNo && (
                        <CommonErrorMsg
                          text="Phone number must be 10 digits"
                          IsError={true}
                        />
                      )}
                      <CommonErrorMsg
                        text="Phone Number is required"
                        IsError={error.ClientPhoneNumber}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                // Non-Meridian Clients Form
                <div key="non-meridian-form" className="form-section margin">
                  <div className="row">
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="name"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="control form-control"
                        placeholder="Enter Your Name"
                        name="Name"
                        value={vendor.Name}
                        data-required="true"
                        onChange={(e) => {
                          setVendor({ ...vendor, Name: e.target.value });
                          onValidation("Name", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text="Name is required"
                        IsError={error.Name}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="email"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Email ID <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="control form-control"
                        placeholder="Enter Email ID"
                        name="Email"
                        value={vendor.Email}
                        data-required="true"
                        onChange={(e) => {
                          setVendor((prev) => ({
                            ...prev,
                            Email: e.target.value,
                          }));
                          onValidation("Email", e.target.value);
                          // Email validation
                          const emailPattern =
                            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

                          // Check if the email is valid or not
                          if (
                            !emailPattern.test(e.target.value) &&
                            e.target.value !== ""
                          ) {
                            setError((prevError) => ({
                              ...prevError,
                              ValidEmail: true,
                            }));
                          } else {
                            setError((prevError) => ({
                              ...prevError,
                              ValidEmail: false,
                            }));
                          }
                        }}
                      />
                      {error.ValidEmail && (
                        <ErrorMsg text="Please provide a valid email address" />
                      )}
                      <CommonErrorMsg
                        text="Email ID is required"
                        IsError={error.Email}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="eventDate"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Event Date
                      </label>
                      <KendoDatePicker
                        name="OutsideEventDate"
                        value={vendor.OutsideEventDate}
                        format="MM/dd/yyyy"
                        onChange={handleOutsideDateChange}
                        disablePast={true}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="phone"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Phone Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="control form-control"
                        placeholder="Enter Phone Number"
                        name="PhoneNumber"
                        value={vendor.PhoneNumber}
                        data-required="true"
                        onChange={(e) => {
                          // Clear previous error message
                          setError((prevError) => ({
                            ...prevError,
                            PhoneNumber: false, // Clear the 'PhoneNumber' required error
                            invalidNo: false, // Clear the 'invalidNo' error state
                          }));

                          let rawValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

                          // Limit the number of digits to 10
                          if (rawValue.length > 10)
                            rawValue = rawValue.substring(0, 10);

                          // Format the phone number as (XXX) XXX-XXXX
                          let formattedValue = "";
                          if (rawValue.length > 3) {
                            formattedValue = `(${rawValue.substring(
                              0,
                              3
                            )}) ${rawValue.substring(3, 6)}${
                              rawValue.length > 6
                                ? "-" + rawValue.substring(6)
                                : ""
                            }`;
                          } else if (rawValue.length > 0) {
                            formattedValue = `(${rawValue}`;
                          }

                          // Update the phone number in the vendor state
                          setVendor((prev) => ({
                            ...prev,
                            PhoneNumber: formattedValue,
                          }));

                          if (rawValue.length === 0) {
                            setError((prevError) => ({
                              ...prevError,
                              PhoneNumber: true, // Set error for empty phone number
                              invalidNo: false, // Clear the invalid number error
                            }));
                          } else if (rawValue.length < 10) {
                            setError((prevError) => ({
                              ...prevError,
                              invalidNo: true, // Set error for invalid number
                              PhoneNumber: false, // Clear the required error
                            }));
                          } else {
                            // Clear all errors if the phone number is valid
                            setError((prevError) => ({
                              ...prevError,
                              PhoneNumber: false,
                              invalidNo: false,
                            }));
                          }

                          onValidation("PhoneNumber", formattedValue);
                        }}
                      />
                      {error.invalidNo && (
                        <CommonErrorMsg
                          text="Phone number must be 10 digits"
                          IsError={true}
                        />
                      )}
                      <CommonErrorMsg
                        text="Phone Number is required"
                        IsError={error.PhoneNumber}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="venueLocation"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Venue Location <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="control form-control"
                        placeholder="Enter Venue Location"
                        name="VenueLocation"
                        value={vendor.VenueLocation}
                        data-required="true"
                        onChange={(e) => {
                          setVendor({
                            ...vendor,
                            VenueLocation: e.target.value,
                          });
                          onValidation("VenueLocation", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text="Venue Location is required"
                        IsError={error.VenueLocation}
                      />
                    </div>
                  </div>
                </div>
              )}

              <button type="submit" className="CartButtons">
                Submit
              </button>
            </form>
          </div>
        </div>
      )}
      {showThankYouModal && (
        <div className="thank-you-popup">
          <div className="thank-you-modal-content">
            <div className="thank-you-modal-container">
              <div className="thank-you-icon-container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="50"
                  height="50"
                  fill="#ffffff"
                >
                  <path d="M9 16.2l-3.6-3.6 1.4-1.4 2.2 2.2 5.6-5.6 1.4 1.4z" />
                </svg>
              </div>
              <h3 className="thank-you-message">
                Your cart is shared. Thank you!
              </h3>
            </div>
          </div>
        </div>
      )}
    </>
  );

  // Function to remove an item
  function removeItem(index) {
    let updatedCart = [...cartItems];
    updatedCart.splice(index, 1); // Remove item at given index

    setCartItems(updatedCart);
    localStorage.setItem("cart_items", JSON.stringify(updatedCart));

    let updatedCount = updatedCart.length;
    setCartCount(updatedCount);
    localStorage.setItem("cart_count", updatedCount);

    window.dispatchEvent(new Event("cartUpdated"));
  }

  // Function to update quantity
  function updateQuantity(index, change) {
    let updatedCart = [...cartItems];
    updatedCart[index].quantity += change;
    if (updatedCart[index].quantity < 1) updatedCart[index].quantity = 1;
    setCartItems(updatedCart);
    localStorage.setItem("cart_items", JSON.stringify(updatedCart));
  }
};
